<template>
  <router-view :key="$route.matched[0]?.name" />
  <LayoutLoader />
  <LayoutToasts />
  <SheetStackHost />
</template>
<script setup lang="ts">
import { RouterView, useRouter } from 'vue-router'
import { useQueryClient } from '@tanstack/vue-query'
import { useAuthStore } from '@/stores/auth'
import { useUserStore } from './stores/user'
import { useEventStore } from './stores/event'
import { watch } from 'vue'
import { clearSheets } from './composables/sheet-stack'
import { clearFilterStorage } from './composables/filter'

const authStore = useAuthStore()
const userStore = useUserStore()
const eventStore = useEventStore()
const queryClient = useQueryClient()
const router = useRouter()

// Watchers
watch(
  () => authStore.isAuthorized,
  (value) => {
    if (!value) {
      clearSheets()
      clearFilterStorage()
      router.push({ name: 'signin' }).then(() => {
        userStore.$reset()
        eventStore.$reset()
      })
    }
  },
)

watch(
  () => eventStore.currentEventId,
  (value, prevValue) => {
    if (prevValue && value !== prevValue) {
      queryClient.clear()
    }
  },
)
</script>
<style lang="sass">
#app
  display: flex
  flex-direction: column
  height: 100svh
</style>
